export enum PermissionType {
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  MOBILE_APP = 'MOBILE_APP',
  APP_ADMIN = 'APP_ADMIN'
}
